export default __webpack_public_path__ + "static/media/mor-chaluz.503bca77.png";